import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import NavBar from 'components/Navigation';
import styles from './ProfileBanner.scss';// to import local scss fle

const ProfileBanner = (props) => {
  const profileBanner = false;
  return (
    <div
      className={props.usedFor === 'pricing' ? cn('row', styles.container) : cn('row', styles.profileBannerContainer)}
    >
      <NavBar profileBanner={profileBanner} {...props} />
      <div className={props.usedFor === 'pricing' ? cn('row', styles.textOnPricingbanner) : cn('row', styles.textOnbanner)}>
        {props.usedFor === 'pricing' ?
          <span>
            Experience the Full Power of MyRecruitBoard
            <span className={styles.smallText}>Upgrade to Premium</span>
          </span>
                    :
          <span>
            Almost there!Complete your profile.
          </span>
                }
      </div>
    </div>
  );
};
ProfileBanner.propTypes = {
  usedFor: PropTypes.string.isRequired,
};


export default ProfileBanner;



// WEBPACK FOOTER //
// ./src/components/ProfileBanner/ProfileBanner.js